<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>Reset application</v-card-title>
      <v-card-text>
        Resetting the application will
        <strong>delete</strong> any locally stored data and sign you out. Its possible to reload your information again by signing in.
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          flat
          class="text-none"
          @click="$emit('reset')"
        >Yes, go ahead and delete my data</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'reset-modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
  }),
  methods:
  {
  },
};
</script>

<style>
</style>
